// extracted by mini-css-extract-plugin
export default {"aboutPage":"About_aboutPage__9izqH"};